/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React, { useCallback, useEffect, useRef } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import {
  RIGHT_RAIL_TABS,
  selectedElementSelector,
  setActiveTab,
  setSelectedElementID,
  setshowRunStepsPanel,
} from '../../../../services/ducks/designerDuck/designerDuck';
import { PANEL_WIDTH } from '../../../../utils/dimensions';
import { AddModulePanel } from '../AddModule/AddModulePanel';
import { EditModule } from '../EditModule';
import { EditTriggers } from '../EditTriggers';
import { RunLog } from '../RunLog';
import { RightPanelContainer } from './RightPanelContainer';
import { PanelBodyWrapper } from './styled/PanelBodyWrapper';
import { StyledSlideWrapper } from './styled/SlideWrapper';

interface RightPanelProps {
  activePanelId: RIGHT_RAIL_TABS | null;
  isOpen: boolean;
}

const runLogStyle = css`
  padding-right: 0;
`;

const useOutsideAlerter = (closePanel: Function): void => {
  useEffect(() => {
    const handleClickOutside = (event: { target: any }): void => {
      const panel = document.querySelector('#right-panel-container');
      if (
        panel &&
        !panel.contains(event.target) &&
        event.target.parentNode.closest('#canvas')
      ) {
        closePanel();
      }
    };
    document.addEventListener('mousedown', handleClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, [closePanel]);
};

export const RightPanel: React.FC<RightPanelProps> = ({
  activePanelId,
  isOpen,
}) => {
  const width = useRef(PANEL_WIDTH);
  const dispatch = useDispatch();
  const closePanel = useCallback(() => {
    batch(() => {
      dispatch(setActiveTab(null));
      dispatch(setshowRunStepsPanel(false));
      dispatch(setSelectedElementID(undefined));
    });
  }, [dispatch]);
  useOutsideAlerter(closePanel);
  const selectedElement = useSelector(selectedElementSelector);

  return (
    <StyledSlideWrapper>
      <RightPanelContainer
        width={`${width.current.toString()}px`}
        isOpen={isOpen && activePanelId !== null}
        panelId="right-panel-container"
      >
        {activePanelId === RIGHT_RAIL_TABS.ADD_MODULE ? (
          <PanelBodyWrapper>
            <AddModulePanel
              key={RIGHT_RAIL_TABS.ADD_MODULE}
              closePanel={closePanel}
            />
          </PanelBodyWrapper>
        ) : null}

        {activePanelId === RIGHT_RAIL_TABS.EDIT_MODULE &&
        selectedElement !== undefined ? (
          <PanelBodyWrapper>
            {selectedElement !== undefined &&
            selectedElement.id == 'trigger' ? (
              <EditTriggers
                key={RIGHT_RAIL_TABS.EDIT_MODULE}
                closePanel={closePanel}
                selectedElement={selectedElement}
              />
            ) : selectedElement !== undefined ? (
              <EditModule
                key={RIGHT_RAIL_TABS.EDIT_MODULE}
                closePanel={closePanel}
                selectedElement={selectedElement}
              />
            ) : null}
          </PanelBodyWrapper>
        ) : null}

        {activePanelId === RIGHT_RAIL_TABS.RUNLOG ? (
          <PanelBodyWrapper css={runLogStyle}>
            <RunLog key={RIGHT_RAIL_TABS.RUNLOG} />
          </PanelBodyWrapper>
        ) : null}
      </RightPanelContainer>
    </StyledSlideWrapper>
  );
};
